/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {useNavigate} from 'react-router-dom'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import Swal from 'sweetalert2'
import {i18n} from '../../../translate/i18n'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import uuid from 'react-uuid'
import {getPlugintypeIdByCode} from '../../../functions/plugintype'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

type mostraSetor = {
  value: string
  select: string
}

// type newSegmento = {
//   pluginspaceId: number
//   segment: number
//   id: number
// }

// type CategoryType = {
//   id: number
//   parent: string
//   code: string
//   name: string
//   shortname: string
//   order: 0
//   img: string
//   status: true
//   subitems: CategoryType[]
// }

type store = {
  id: number
  pluginspaceId: number
  aggregatorId: number
  classificationId: number
  order: number
  name: string
  description: string
  image: string
  link: string
  type: string
  active: boolean
  exclusive: boolean
  exclusivo?: string
  instagram?: any
  phoneWhatsapp: string
  latitude: string
  longitude: string
  zipCode: number
  created: string
  updated: string
  status?: string
  subdomain?: string
}

const ContaContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [showCategorias, setShowCategorias] = useState<mostraSetor[]>([])
  const [showSubCategorias, setShowSubCategorias] = useState<mostraSetor[]>([])
  const [saveSubcategoria, setSaveSubcategoria] = useState<mostraSetor[]>([])
  const [categoriaCreate, setCategoriaCreate] = useState<string>('')
  const [subCategoriaCreate, setSubCategoriaCreate] = useState<string>('')
  const [lojaCreate, setLojaCreate] = useState<string>('')
  const [showStore, setShowStore] = useState<mostraSetor[]>([])
  const [allStores, setAllStores] = useState<store[]>([])
  const [ordemCreate, setOrdemCreate] = useState<number>(0)
  const [status, setStatus] = useState<any>(false)
  const [statusLink, setStatusLink] = useState<any>(false)
  const [statusLinkLive, setStatusLinkLive] = useState<any>(false)
  const [dateInit, setDateInit] = useState<any>(null)
  const [dateFin, setDateFin] = useState<any>(null)
  const [lojaLink, changeLojaLink] = useState<string>('')
  const [liveLink, setLiveLink] = useState<string>('')
  const [hourInit, setHourInit] = useState<string>('00:00:00')
  const [hourFin, setHourFin] = useState<string>('00:00:00')
  const [imagePricipal, setImagePricipal] = useState<any>(null)
  const [showImages, setShowImages] = useState<any>([])
  const {showWrapperModal} = useModals()

  const getCategories = async () => {
    try {
      const res = await POST(`/classification/filter`, {
        plugintypeId: getPlugintypeIdByCode('service'),
        deleted: 'not show',
      })

      let subCategorys = res.data.filter((classification: any) => classification.parent !== null)

      await safeSubcategory(subCategorys)

      const showCategorias = subCategorys.map((categoria: any, i: any) => {
        return {
          select: categoria.name,
          value: categoria.id,
        }
      })

      const selectUnicos = new Set<string>()
      const showCategoriasUnicas = showCategorias.filter((obj: any) => {
        if (!selectUnicos.has(obj.select)) {
          selectUnicos.add(obj.select)
          return true
        }
        return false
      })

      setShowCategorias(showCategoriasUnicas)
    } catch (e) {
      console.log(e)
    }
  }

  const safeSubcategory = async (subCat: any) => {
    setSaveSubcategoria(subCat)
  }

  const selectSubCategory = async (nameCategory: any) => {
    try {
      const showSubCategory = saveSubcategoria.filter((item) => {
        const itemValues = Object.values(item)
        return itemValues.includes(nameCategory)
      })

      const showCategoriasFilter = showSubCategory.map((subCategoria: any) => {
        return {
          select: subCategoria.shortname,
          value: subCategoria.id,
        }
      })

      setShowSubCategorias(showCategoriasFilter)
    } catch (error) {
      console.log(error)
    }
  }

  async function getData(valueId: any) {
    try {
      const res = await GET('pluginspaceaggregator')
      if (res.success) {
        const data: store[] = res.data

        const showLojas = data.filter((item) => {
          const itemValues = Object.values(item)
          return itemValues.includes(Number(valueId))
        })

        if (showLojas.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção',
            text: 'Não há nenhuma loja cadastrada para essa subcategoria.',
          })
        } else {
          const showLojasFilter = showLojas.map((subCategoria: any) => {
            return {
              select: subCategoria.name,
              value: subCategoria.id,
            }
          })

          setShowStore(showLojasFilter)
          setAllStores(data)
        }
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao recuperar lojas',
      })
      console.log(error)
    }
  }

  useEffect(() => {
    setLoading(true)
    getCategories()
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createPublicidade = async () => {
    try {
      if (
        !dateInit ||
        !dateFin ||
        !hourFin ||
        !hourInit ||
        !Object.values(lojaCreate)[0] ||
        !Object.values(subCategoriaCreate)[0] ||
        !imagePricipal
      ) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        const divirdirSuffix = await quebrarURL(imagePricipal)

        const res = await POST('/publication-aggregator', {
          order: ordemCreate,
          path: 'https://s3.amazonaws.com/img.ninegrid.com/',
          imgSuffix: divirdirSuffix,
          typeImg: 'image',
          classificationId: Object.values(subCategoriaCreate)[0],
          startDate: `${dateInit} ${hourInit}`,
          endDate: `${dateFin} ${hourFin}`,
          status: status,
          storeId: Object.values(lojaCreate)[0],
          statusLink: statusLink,
          link: lojaLink || liveLink || '',
          statusLinkLive: statusLinkLive,
        })

        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Publicidade cadastrada',
            text: 'Cadastro realizado com sucesso!',
          }).then(() => navigate('/agregador/publicidade'))
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar a publicidade!',
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const quebrarURL = async (url: any) => {
    const dividirUrl = url.split('https://s3.amazonaws.com/img.ninegrid.com/')

    return dividirUrl[1]
  }

  const imageSelect = async () => {
    try {
      showWrapperModal('Imagens - Banner da loja')
    } catch (error) {
      console.log(error)
    }
  }

  const imageUploadSelect = async (event: any) => {
    try {
      const file = event.target.files[0]
      const formData = new FormData()
      formData.append('file', file)
      formData.append('nameImage', `store-${'teste'}-${uuid()}.jpg`)
      formData.append('originalSize', 'true')
      const imageRes = await POST('/upload-images/upload-one', formData)
      return imageRes.success ? setImagePricipal(imageRes.image) : ''
    } catch (error) {
      console.log(error)
    }
  }

  const getImageStore = async (store: any) => {
    try {
      const idStore = Object.values(store)[0]

      const getStore: any = allStores.filter((storeCmp: any) => storeCmp.id === idStore)
      const getImageStore = getStore[0].config.images

      setShowImages(getImageStore)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='card py-4 px-11'>
          <div className='row'>
            <div>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Criar Banner Destaque</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Preencha as informações abaixo e clique no botão salvar para criar um novo banner.
                </span>
              </h3>
            </div>
            <div className='col d-flex flex-column border-end mb-8'>
              <div className='d-flex gap-12'>
                <div className='w-50 mt-6'>
                  <div>
                    <label className='form-label fw-normal'>Categoria</label>
                    <Input
                      inputAttr={{
                        type: 'select-publicidade',
                      }}
                      options={showCategorias}
                      placeholder={'Categoria'}
                      search={true}
                      value={categoriaCreate}
                      change={(value: any) => {
                        setCategoriaCreate(value)
                        setSubCategoriaCreate('')
                        setLojaCreate('')
                        setShowStore([])
                        selectSubCategory(value.label)
                        setImagePricipal('')
                      }}
                    />
                  </div>
                </div>
                <div className='w-50 mt-6'>
                  <div>
                    <label className='form-label fw-normal'>Subcategoria</label>
                    <Input
                      inputAttr={{
                        type: 'select-publicidade',
                      }}
                      options={showSubCategorias}
                      placeholder={'Subcategoria'}
                      search={true}
                      value={subCategoriaCreate}
                      change={(value: any) => {
                        setSubCategoriaCreate(value)
                        getData(value.value)
                        setImagePricipal('')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className='mt-6'>
                  <label className='form-label fw-normal'>Nome da Loja</label>
                  <Input
                    inputAttr={{
                      type: 'select-publicidade',
                    }}
                    options={showStore}
                    placeholder={'Loja'}
                    search={true}
                    value={lojaCreate}
                    change={(value: any) => {
                      setLojaCreate(value)
                      getImageStore(value)
                      setImagePricipal('')
                    }}
                  />
                </div>
              </div>
              <div className='mt-9 d-flex gap-12'>
                <div className='d-flex gap-2'>
                  <div className='align-self-center'>
                    <label>Ordem</label>
                  </div>
                  <Input
                    inputAttr={{
                      type: 'number-agregador',
                    }}
                    placeholder={'0'}
                    value={ordemCreate}
                    change={(value: number) => setOrdemCreate(value)}
                  />
                </div>
                <div className='d-flex'>
                  <Input
                    inputAttr={{
                      type: 'checkbox',
                    }}
                    search
                    label={'Ativo'}
                    value={status}
                    checked={status}
                    checkSwift={true}
                    change={(value: any) => {
                      setStatus(value)
                    }}
                  />
                </div>
              </div>
              <div className='d-flex gap-6 mt-2'>
                <div className='row d-flex justify-content-between w-100 gap-6'>
                  <div className='col d-flex gap-6 mt-5 w-100'>
                    <div className='d-flex  justify-content-center align-items-center'>
                      <img
                        src={toAbsoluteUrl('/media/svg/aggregator/calendario.svg')}
                        alt=''
                        style={{
                          height: '42px',
                        }}
                      />
                    </div>
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      label={'Data de inicio'}
                      value={dateInit}
                      change={(value: string) => setDateInit(value)}
                    />
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      label={'Data de fim'}
                      value={dateFin}
                      change={(value: string) => setDateFin(value)}
                    />
                  </div>
                  <div
                    className='col d-flex gap-6 mt-5 w-100 grow'
                    style={{
                      minWidth: '250px',
                    }}
                  >
                    <Input
                      inputAttr={{
                        type: 'time',
                      }}
                      label={'Início'}
                      value={hourInit}
                      change={(value: string) => setHourInit(value)}
                    />
                    <Input
                      inputAttr={{
                        type: 'time',
                      }}
                      label={'Termino'}
                      value={hourFin}
                      change={(value: string) => setHourFin(value)}
                    />
                  </div>
                </div>
              </div>
              <div className='mt-8 d-flex align-itens-center justify-content-between flex-wrap'>
                <div>
                  <div className='d-flex align-itens-end'>
                    <div>
                      <Input
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        name='link_publication'
                        disabled={statusLinkLive}
                        value={statusLink}
                        checked={statusLink}
                        label='Link para loja'
                        change={(value: any) => {
                          setLiveLink('')
                          setStatusLinkLive(false)
                          setStatusLink(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex align-itens-end gap-3'>
                    <Input
                      inputAttr={{
                        type: 'link-agregador',
                      }}
                      value={lojaLink}
                      disabled={statusLinkLive}
                      label='Link:'
                      change={(value: any) => {
                        changeLojaLink(value)
                      }}
                    />
                  </div>
                </div>

                <div>
                  <div className='d-flex align-itens-end'>
                    <div>
                      <Input
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        name='link_publication'
                        disabled={statusLink}
                        value={statusLinkLive}
                        checked={statusLinkLive}
                        label='Link para Live'
                        change={(value: any) => {
                          setStatusLink(false)
                          changeLojaLink('')
                          setStatusLinkLive(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex align-itens-end gap-3'>
                    <Input
                      inputAttr={{
                        type: 'link-agregador',
                      }}
                      value={liveLink}
                      disabled={statusLink}
                      label='Link:'
                      change={(value: any) => {
                        setLiveLink(value)
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='col d-flex flex-column ' style={{gap: '62px'}}>
              <div className='d-flex flex-cloumn justify-content-center'>
                <div className='d-flex flex-column gap-6'>
                  <div onClick={imageSelect} style={{cursor: 'pointer', fontSize: '1.4rem'}}>
                    <div className='d-flex gap-8 align-items-center'>
                      <img
                        src={toAbsoluteUrl('/media/svg/aggregator/image.svg')}
                        alt=''
                        className='h-42px'
                      />
                      <span>Usar imagens de bannes cadastrados no loja</span>
                    </div>
                  </div>
                  <div style={{cursor: 'pointer'}}>
                    <div className='d-flex gap-8 align-items-center'>
                      <img
                        src={toAbsoluteUrl('/media/svg/aggregator/upload.svg')}
                        alt=''
                        className='h-42px'
                      />
                      <input
                        type='file'
                        accept='.jpg, .jpeg, .png, .gif'
                        name='file'
                        onChange={(event) => imageUploadSelect(event)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-cloumn justify-content-center'>
                <Input
                  inputAttr={{
                    type: 'image-agregador',
                  }}
                  width='400'
                  height='250'
                  value={imagePricipal}
                />
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between pb-10'>
            <Button
              text={i18n.t(`buttons.back`)}
              color='info'
              size='small'
              horizontalPadding={6}
              btnAttr={{
                type: 'button',
              }}
              click={() => navigate(-1)}
              btnClass='fw-bolder'
            />
            <Button
              text={i18n.t(`buttons.save`)}
              color='primary'
              size='small'
              horizontalPadding={5}
              btnAttr={{
                type: 'button',
              }}
              click={() => createPublicidade()}
              btnClass='fw-bolder'
            />
          </div>
        </div>
      )}

      {/* <div style={{ width: 'auto', position: 'fixed', bottom: 40, right: 60 }}>
                <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => navigate(-1)}
                    btnClass='fw-bolder m-9'
                />
                <Button
                    text={i18n.t(`buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => createPublicidade()}
                    btnClass='fw-bolder'
                />
            </div> */}
      <ModalWrapper confirmAction={() => {}} maxWidth={true} width={40}>
        <div
          className='d-flex  flex-column gap-5 card'
          style={{
            height: '20rem',
          }}
        >
          <div className='card-body d-flex gap-5 flex-row flex-wrap overflow-auto justify-content-center'>
            {showImages.map((image: any) => (
              <div
                className={`d-flex flex-column p-4 border border-2 ${
                  image.image === imagePricipal ? 'border-primary' : 'border-none'
                } cursor-pointer`}
                onClick={() => setImagePricipal(image.image)}
              >
                <img src={image.image} style={{width: '150px', height: '150px'}} alt='' />
              </div>
            ))}
          </div>
        </div>
      </ModalWrapper>
    </>
  )
}

const CriarPublicidadeAgregador: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`Criar publicidade agregador`),
            path: '/agregador/publicidade/create',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`Criar publicidade agregador`)}
      </PageTitle>
      <ContaContent />
    </>
  )
}

export {CriarPublicidadeAgregador}
